export interface PromoTypeProps {
  promoTypeId: number;
  promoTypeName: string;
  promoTypeCode: string;
  promoTypeKey: string;
}

export class PromoType {
  private readonly _promoTypeId: number;
  private readonly _promoTypeName: string;
  private readonly _promoTypeCode: string;
  private readonly _promoTypeKey: string;

  constructor(props: PromoTypeProps) {
    this._promoTypeId = props.promoTypeId;
    this._promoTypeName = props.promoTypeName;
    this._promoTypeCode = props.promoTypeCode;
    this._promoTypeKey = props.promoTypeKey;
  }

  public get promoTypeId(): number {
    return this._promoTypeId;
  }

  public get promoTypeName(): string {
    return this._promoTypeName;
  }

  public get promoTypeCode(): string {
    return this._promoTypeCode;
  }

  public get promoTypeKey(): string {
    return this._promoTypeKey;
  }
}
